export default '/build/0b512cf1.svg'